import type { JSX } from "solid-js";

import { cn } from "@/lib/tailwindcssTool";

import "./index.css";

interface GradientBorderButtonProps {
  /** 按钮内容 */
  children: JSX.Element;
  /** 渐变背景类 */
  wrapClass?: string;
  /** 边框背景类 */
  borderClass?: string;
  onClick?: () => void;
}
export default function GradientBorderButton(props: GradientBorderButtonProps) {
  return (
    <div
      class={cn(
        "gradient-border-button bg-linear-180 from-(--colors-surface-bg-9) to-(--colors-surface-bg-7) relative overflow-hidden rounded-[8px]",
        props.wrapClass,
      )}
      onClick={props.onClick}
    >
      {/* 实际渲染内容 */}
      <div class="relative z-10 cursor-pointer">{props.children}</div>
      {/* 中间镂空渐变边框 */}
      <div
        class={cn(
          "hollow-border bg-linear-180 from-(--colors-btn-border-fade-0) to-(--colors-btn-border-fade-5) p-px",
          props.borderClass,
        )}
      />
    </div>
  );
}
